import { InventoryCountItem, InventoryCountScope, ProductStockEntityType } from './stock.types';

export interface InventoryCountScopeNode {
  stockItemId: string;
  entityType: ProductStockEntityType;
  /** Categoría del producto (para el filtro `partial`); irrelevante para option-items. */
  categoryId: string;
  /** Stock esperado del `productStock`, o `null` si el ítem no tiene control (infinito). */
  expectedQty: number | null;
}

export interface InventoryCountScopeParams {
  scope: InventoryCountScope;
  scopeCategoryIds?: string[];
  includeOptionItems: boolean;
}

/**
 * Snapshot del scope al iniciar un conteo: filtra los nodos (TODO el catálogo en scope, tengan o no
 * control de stock) y arma el mapa `stockItems` con el esperado congelado (`e` = stock o `null` si sin
 * control) y `c: null`. `full` = todos los productos/presentaciones; `partial` = solo las categorías
 * elegidas (ninguna elegida → ningún producto: se usa para contar SOLO los adicionales). Los option-items
 * entran solo si `includeOptionItems` (para el cliente no pertenecen a una categoría — es un toggle propio,
 * no un filtro por categoría). Puro.
 */
export function buildInventoryCountItems(
  nodes: InventoryCountScopeNode[],
  { scope, scopeCategoryIds, includeOptionItems }: InventoryCountScopeParams,
): Record<string, InventoryCountItem> {
  const partial = scope === 'partial';
  const categoryIds = scopeCategoryIds ?? [];
  const stockItems: Record<string, InventoryCountItem> = {};

  for (const node of nodes) {
    if (node.entityType === 'option-item') {
      if (!includeOptionItems) {
        continue;
      }
    } else if (partial && !categoryIds.includes(node.categoryId)) {
      continue;
    }

    stockItems[node.stockItemId] = { e: node.expectedQty, c: null };
  }

  return stockItems;
}
